<template>
    <v-container class="m-3">
      <v-card class="mx-auto mt-4" max-width="800">
        <v-row class="justify-center">
          <v-img :src="imageUrl" max-height="300" contain class="mt-4"></v-img>
        </v-row>
        <v-row class="mx-0 justify-center" align="stretch">
          <v-col cols="12" sm="12" md="4">
            <v-card height="100%" outlined>
              <v-card-title class="d-flex justify-space-between align-center">
                OpenAI
                <v-progress-circular
                v-if="response.openai.status === 'success'"
                  :value="response.openai.data.valutazione"
                  :color="getColor(response.openai.data.valutazione)"
                  size="50"
                  width="8"
                  :rotate="-90"
                >
                  {{ response.openai.data.valutazione }}
                </v-progress-circular>
              </v-card-title>
              <v-card-subtitle v-if="response.openai && response.openai.status === 'success'">
                <p :style="{ color: response.openai.data.violazione === 'true' ? 'red' : 'green' }">
                  {{ response.openai.data.violazione === 'true' ? 'Violazione rilevata!' : 'Nessuna violazione' }}
                </p>
              </v-card-subtitle>
              <v-card-subtitle v-else>
                <p style="color:red">
                  {{ response.openai.error }}
                </p>
              </v-card-subtitle>
              <v-card-text v-if="response.openai.status === 'success'">
                <p><strong>Descrizione:</strong> {{ response.openai.data.descrizione }}</p>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12" sm="12" md="4">
            <v-card height="100%" outlined>
              <v-card-title class="d-flex justify-space-between align-center">
                Gemini AI
                <v-progress-circular
                v-if="response.gemini.status === 'success'"
                  :value="response.gemini.data.valutazione"
                  :color="getColor(response.gemini.data.valutazione)"
                  size="50"
                  width="8"
                  :rotate="-90"
                >
                  {{ response.gemini.data.valutazione }}
                </v-progress-circular>
              </v-card-title>
              <v-card-subtitle v-if="response.gemini && response.gemini.status === 'success'">
                <p :style="{ color: response.gemini.data.violazione === 'true' ? 'red' : 'green' }">
                  {{ response.gemini.data.violazione === 'true' ? 'Violazione rilevata!' : 'Nessuna violazione' }}
                </p>
              </v-card-subtitle>
              <v-card-subtitle v-else>
                <p style="color:red">
                  {{ response.gemini.error }}
                </p>
              </v-card-subtitle>
              <v-card-text v-if="response.gemini.status === 'success'">
                <p><strong>Descrizione:</strong> {{ response.gemini.data.descrizione }}</p>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12" sm="12" md="4">
            <v-card height="100%" outlined>
              <v-card-title class="d-flex justify-space-between align-center">
                Claude AI
                <v-progress-circular
                v-if="response.claude.status === 'success'"
                  :value="response.claude.data.valutazione"
                  :color="getColor(response.claude.data.valutazione)"
                  size="50"
                  width="8"
                  :rotate="-90"
                >
                  {{ response.claude.data.valutazione }}
                </v-progress-circular>
              </v-card-title>
              <v-card-subtitle v-if="response.claude && response.claude.status === 'success'">
                <p :style="{ color: response.claude.data.violazione ? 'red' : 'green' }">
                  {{ response.claude.data.violazione ? 'Violazione rilevata!' : 'Nessuna violazione' }}
                </p>
              </v-card-subtitle>
              <v-card-subtitle v-else>
                <p style="color:red">
                  {{ response.claude.error }}
                </p>
              </v-card-subtitle>
              <v-card-text v-if="response.claude.status === 'success'">
                <p><strong>Descrizione:</strong> {{ response.claude.data.descrizione }}</p>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-card>
    </v-container>
  </template>

  <script>
  export default {
    props: {
      imageUrl: {
        type: String,
        required: true,
      },
      response: {
        type: Object,
        default: null,
      },
    },
    methods: {
      getColor(valutazione) {
        if (valutazione < 60) return 'red';
        if (valutazione >= 60 && valutazione <= 80) return 'yellow';
        return 'green';
      },
    },
  };
  </script>

  <style scoped>
  .v-img {
    max-width: 100%;
    object-fit: contain;
  }
  </style>
